import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=4ceec396&"
import script from "./PageIndex.vue?vue&type=script&lang=js&"
export * from "./PageIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=4ceec396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports